import { useMemo } from "react";
import { PresenceKind } from "@common/types/presence-nats";
import { usePresenceViewers } from "@hooks/presence/usePresenceViewers";
import { parseCloseId } from "@hooks/useOpenWorkRow";
import { useScope } from "@state/scopeContext.lib";
import { OrganizationViewers } from "./OrganizationViewers";

interface WorkViewersProps {
    closeId: string;
    workspaceId: string;
}

/** The ids of the other users viewing a task of the work item (close), on the organization. */
export const useWorkViewerIds = ({
    closeId,
    workspaceId,
}: WorkViewersProps) => {
    const { organizationId } = useScope();

    const target = useMemo(
        () =>
            organizationId
                ? {
                      scope: { organizationId },
                      kind: PresenceKind.WORK,
                      workspaceId,
                      targetId: parseCloseId(closeId) ?? closeId,
                  }
                : null,
        [organizationId, workspaceId, closeId],
    );

    return usePresenceViewers(target);
};

/** Who is viewing a task of the work item (close) on an organization-wide table. */
export const WorkViewers = (props: WorkViewersProps) => (
    <OrganizationViewers userIds={useWorkViewerIds(props)} />
);
